import { DataSource, Label, Layout, Panel, SearchPanel, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutViewMovementList extends Layout {
    labelCategory: Label;
    labelCategoryValue: Label;
    labelD: Label;
    labelE: Label;
    labelLoaded2: Label;
    labelMileage: Label;
    labelMileageDeadhead: Label;
    labelMileageEmpty: Label;
    labelMileageLoaded: Label;
    labelMileageTotal: Label;
    labelPerMileLoaded: Label;
    labelPerMileT: Label;
    labelR: Label;
    labelRatesPerMileLoaded: Label;
    labelRatesPerMileTotal: Label;
    labelRatesTotal: Label;
    labelTotal1: Label;
    labelTotal2: Label;
    panelHeader1: Panel;
    panelHeader2: Panel;
    panelHeader3: Panel;
    panelHeader: Panel;
    panelHeaderSection1: Panel;
    panelLoaded: Panel;
    panelMileage: Panel;
    panelMileageDeadhead: Panel;
    panelMileageEmpty: Panel;
    panelMileageTotal: Panel;
    panelPerMileLoaded: Panel;
    panelRates: Panel;
    panelRatesPerMile: Panel;
    panelRatesTotal: Panel;
    panelSuperHeader: Panel;
    searchpanel1: SearchPanel;
    sourceViewMovements: DataSource;
    switchShowVoidedMoves: Switch;
    tableResults: Table;
    textboxCutoffDate: Textbox;
    textboxDays: Textbox;
    textboxSearchBy: Textbox;
    textboxSearchByDriver: Textbox;
    textboxSearchByOrder: Textbox;
    textboxSearchByTractor: Textbox;
    textboxSearchByTrailer: Textbox;
}
